import { Grid, useMediaQuery } from "@wayflyer/flyui";
import { styled } from "styled-components";

import { Connector as ConnectorLogoButton } from "../connector-button";

import type { Connectors } from "./interface";

export interface ConnectorContentGridProps {
  connectors: Connectors;
  isStaff?: boolean;
}

const ConnectorContainer = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  width: 100%;
`;

const showGoogle = (slug, isStaff) => {
  return ["ga", "adworns", "ga2", "google_ads2"].includes(slug) && isStaff;
};
export const ConnectorContentGrid = ({ connectors, isStaff }: ConnectorContentGridProps) => {
  const query = useMediaQuery();
  const spacing = query("xs").windowLte ? 8 : 16;

  return Array.isArray(connectors) ? (
    <ConnectorContainer>
      <Grid columns={2} spacing={spacing}>
        {connectors.map((connectorProps, key) =>
          showGoogle(connectorProps.slug, isStaff) ? (
            <div key={key}>
              <ConnectorLogoButton {...connectorProps} mode="FullLogo" />
              <ConnectorLogoButton {...connectorProps} key={key} mode="Google" />
            </div>
          ) : (
            <ConnectorLogoButton {...connectorProps} mode="FullLogo" key={key} />
          )
        )}
      </Grid>
    </ConnectorContainer>
  ) : null;
};
